document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.camera-ring-swiper', {
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    });
  
    const openBtn = document.querySelector(".camera-easy-installation");
    const closeBtn = document.querySelector(".camera-close-btn");
    const overlay = document.querySelector(".camera-video-overlay");
    const popup = document.querySelector(".camera-video-popup");
    const video = document.getElementById("camera-youtube-video");
  
    if (openBtn && closeBtn && overlay && popup && video) {
      openBtn.addEventListener("click", function () {
        overlay.style.display = "block";
        popup.style.display = "block";
        video.play();
      });
  
      closeBtn.addEventListener("click", function () {
        overlay.style.display = "none";
        popup.style.display = "none";
        video.pause();
      });
  
      overlay.addEventListener("click", function () {
        overlay.style.display = "none";
        popup.style.display = "none";
        video.pause();
      });
    }
  });
  